import React, { useState, useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import './Solution.css';
import Header from '../../components/Header/Header';
import Footer from '../../components/Footer/Footer';
import Banner from '../../components/Banner/Banner';

// 이미지 import
import solutionbannerimg from '../../images/solution/solution_banner_2.png';
import beforeImg from '../../images/solution/CfSM_before.png';
import afterImg from '../../images/solution/CfSM_after.png';
import arrowIcon from '../../images/solution/icon_arrow.png';
import captureImg from '../../images/solution/CfSM_capture.png';
import combineImg from '../../images/solution/CfSM_combine.png';
import processImg from '../../images/solution/CfSM_process.png';
import monitorImg from '../../images/solution/CfSM_monitor.png';
import hdSafetyMapImg from '../../images/solution/hd_safety_map.png';
import automaticDataProcessingGif from '../../images/solution/automatic_data_processing.gif';
import automaticPlatformImg from '../../images/solution/automatic_platfrom.png';

const ThreeDModels = [
  {
    id: 1,
    iframe: (
      <iframe
        src="https://sketchfab.com/models/18a444fe6d0348958ded01f846269f81/embed?autostart=1&ui_controls=0&ui_infos=0&ui_watermark=0&ui_hint=0&ui_annotations=0&ui_stop=0&ui_settings=0&ui_inspector=0&ui_help=0"
        frameBorder="0"
        allow="autoplay; fullscreen; xr-spatial-tracking"
        mozallowfullscreen="true"
        webkitallowfullscreen="true"
      ></iframe>
    ),
    // caption: (
    //   <p className="model-caption">
    //     <a
    //       href="https://sketchfab.com/models/18a444fe6d0348958ded01f846269f81"
    //       target="_blank"
    //       rel="noopener noreferrer"
    //     >
    //       Surisan-20161123 Simplified 3D Mesh
    //     </a>
    //   </p>
    // ),
  },
  {
    id: 2,
    iframe: (
      <iframe
        src="https://sketchfab.com/models/fedb5948d35b490d9ce0c65f017cb86f/embed?autostart=1&ui_controls=0&ui_infos=0&ui_watermark=0&ui_hint=0&ui_annotations=0&ui_stop=0&ui_settings=0&ui_inspector=0&ui_help=0"
        frameBorder="0"
        allow="autoplay; fullscreen; xr-spatial-tracking"
        mozallowfullscreen="true"
        webkitallowfullscreen="true"
      ></iframe>
    ),
    // caption: (
    //   <p className="model-caption">
    //     <a
    //       href="https://sketchfab.com/models/fedb5948d35b490d9ce0c65f017cb86f"
    //       target="_blank"
    //       rel="noopener noreferrer"
    //     >
    //       DJI House 3D Mesh
    //     </a>{' '}
    //     by{' '}
    //     <a href="https://sketchfab.com/stefano0620" target="_blank" rel="noopener noreferrer">
    //       stefano0620
    //     </a>
    //   </p>
    // ),
  },
  {
    id: 3,
    iframe: (
      <iframe
        src="https://sketchfab.com/models/66f365b83324486cb408c622714c2844/embed?autostart=1&ui_controls=0&ui_infos=0&ui_watermark=0&ui_hint=0&ui_annotations=0&ui_stop=0&ui_settings=0&ui_inspector=0&ui_help=0"
        frameBorder="0"
        allow="autoplay; fullscreen; xr-spatial-tracking"
        mozallowfullscreen="true"
        webkitallowfullscreen="true"
      ></iframe>
    ),
    // caption: (
    //   <p className="model-caption">
    //     <a
    //       href="https://sketchfab.com/models/66f365b83324486cb408c622714c2844"
    //       target="_blank"
    //       rel="noopener noreferrer"
    //     >
    //       Model Building by DJI (3D Mesh)
    //     </a>
    //   </p>
    // ),
  },
  {
    id: 4,
    iframe: (
      <iframe
        src="https://sketchfab.com/models/71f47e1fbd1f48c2833b6b10afa34efe/embed?autostart=1&ui_controls=0&ui_infos=0&ui_watermark=0&ui_hint=0&ui_annotations=0&ui_stop=0&ui_settings=0&ui_inspector=0&ui_help=0"
        frameBorder="0"
        allow="autoplay; fullscreen; xr-spatial-tracking"
        mozallowfullscreen="true"
        webkitallowfullscreen="true"
      ></iframe>
    ),
    // caption: (
    //   <p className="model-caption">
    //     <a
    //       href="https://sketchfab.com/models/71f47e1fbd1f48c2833b6b10afa34efe"
    //       target="_blank"
    //       rel="noopener noreferrer"
    //     >
    //       Hansei-20161207 Simplified 3D Mesh
    //     </a>
    //   </p>
    // ),
  },
];

const Solution = () => {
  const [currentIndex, setCurrentIndex] = useState(0);
  const { t } = useTranslation('solution'); // About namespace 사용
  const [isPaused, setIsPaused] = useState(false);
  const location = useLocation(); // hash 감지를 위한 useLocation
  const navigate = useNavigate();

  const prev = () => {
    setCurrentIndex((prev) => (prev === 0 ? ThreeDModels.length - 1 : prev - 1));
  };

  const next = () => {
    setCurrentIndex((prev) => (prev === ThreeDModels.length - 1 ? 0 : prev + 1));
  };

  // 자동 루프 (3초마다 next), hover 시 정지
  useEffect(() => {
    if (isPaused) return; // hover 중이면 멈춤
    const interval = setInterval(() => {
      setCurrentIndex((prev) => (prev === ThreeDModels.length - 1 ? 0 : prev + 1));
    }, 8000);
    return () => clearInterval(interval);
  }, [isPaused]);

  useEffect(() => {
    if (location.hash) {
      const id = location.hash.replace('#', '');
      window.scrollTo(0, 0);
      requestAnimationFrame(() => {
        const target = document.getElementById(id);
        if (target) {
          target.scrollIntoView({ behavior: 'auto', block: 'start' });
        }
      });
    } else {
      window.scrollTo({ top: 0, behavior: 'auto' });
    }
  }, [location]);

  useEffect(() => {
    const handlePopState = () => {
      if (document.referrer.includes(window.location.origin)) {
        const scrollY = sessionStorage.getItem('mainScrollY');
        if (scrollY) {
          setTimeout(() => {
            window.scrollTo(0, parseInt(scrollY));
          }, 100); // 약간의 딜레이 후 복원
        }
      }
    };
    window.addEventListener('popstate', handlePopState);
    return () => window.removeEventListener('popstate', handlePopState);
  }, []);

  return (
    <>
      <Header />
      <div className="Header_Block"></div>
      <Banner src={solutionbannerimg} alt="Solution 배너" />
      <div className="solution_container">
        <div id="cfsm" className="solution_section1">
          <div className="solution_section1_title">
            <div>
              <div>CfSM</div>
              <p>Car-free Street Mapping</p>
            </div>
          </div>
          <div className="solution_section1_img_contents">
            <div>
              <div>
                <div className="solution_section1_img_contents_title">Before</div>
                <div className="before">
                  <img
                    data-aos="fade"
                    data-aos-delay=""
                    data-aos-easing="ease-out"
                    data-aos-duration="1300"
                    src={beforeImg}
                    alt="CfSM 전 이미지"
                  />
                </div>
              </div>
              <div>
                <div className="icon_arrow">
                  <img src={arrowIcon} alt="화살표 아이콘" />
                </div>
              </div>
              <div>
                <div className="solution_section1_img_contents_title">After</div>
                <div className="after">
                  <img
                    data-aos="fade"
                    data-aos-delay="1000"
                    data-aos-easing="ease-out"
                    data-aos-duration="1300"
                    src={afterImg}
                    alt="CfSM 후 이미지"
                  />
                </div>
              </div>
            </div>
            <div className="solution_section1_description">
              <div>{t('section1.des')}</div>
              <div>{t('section1.des1')}</div>
            </div>
          </div>
        </div>
        <div
          data-aos="fade-up"
          data-aos-easing="ease-out"
          data-aos-duration="1300"
          className="solution_section2"
        >
          {/* <div className="vertical_line">
            <hr />
          </div> */}
          <div className="solution_section2_step1">
            <div className="solution_section2_step1_title">
              <div className="circle_blue"></div>
              <div>Capture</div>
            </div>
            <div className="solution_section2_step1_content">
              <div>
                <img src={combineImg} alt="CfSM 결합" />
              </div>
              <div className="solution_section2_step1_description">
                <div>{t('step1.des')}</div>
              </div>
            </div>
          </div>
          <div className="solution_section2_step1">
            <div className="solution_section2_step1_title">
              <div className="circle_blue"></div>
              <div>Combine</div>
            </div>
            <div className="solution_section2_step1_content">
              <div>
                <img src={captureImg} alt="CfSM 캡쳐" />
              </div>
              <div className="solution_section2_step1_description">
                <div>{t('step2.des')}</div>
              </div>
            </div>
          </div>
          <div className="solution_section2_step1">
            <div className="solution_section2_step1_title">
              <div className="circle_blue"></div>
              <div>Process</div>
            </div>
            <div className="solution_section2_step1_content">
              <div>
                <img src={processImg} alt="CfSM 프로세스" />
              </div>
              <div className="solution_section2_step1_description">
                <div>{t('step3.des')}</div>
              </div>
            </div>
          </div>
          <div className="solution_section2_step1">
            <div className="solution_section2_step1_title">
              <div className="circle_blue"></div>
              <div>Monitor</div>
            </div>
            <div className="solution_section2_step1_content">
              <div>
                <img src={monitorImg} alt="CfSM 모니터링" />
              </div>
              <div className="solution_section2_step1_description">
                <div>{t('step4.des')}</div>
              </div>
            </div>
          </div>
        </div>

        <div
          data-aos="fade-up"
          data-aos-easing="ease-out"
          data-aos-duration="1300"
          className="solution_section3"
        >
          <div id="modeling" className="solution_section3_title">
            <div>3D MODELING</div>
            <div className="solution_section3_description">{t('section3.des')}</div>
          </div>

          <div className="Solution_section3_ContentsBox">
            <div className="carousel-container">
              <div className="carousel-container_box">
                <button
                  className="nav-button"
                  onClick={prev}
                  onMouseEnter={() => setIsPaused(true)}
                  onMouseLeave={() => setIsPaused(false)}
                >
                  〈
                </button>
                {/* 페이드 전환 + hover 시 멈춤 */}
                <div
                  className={`model-display fade`}
                  onMouseEnter={() => setIsPaused(true)}
                  onMouseLeave={() => setIsPaused(false)}
                  key={currentIndex}
                >
                  {ThreeDModels[currentIndex].iframe}
                  {/* {ThreeDModels[currentIndex].caption} */}
                </div>

                <button
                  className="nav-button"
                  onClick={next}
                  onMouseEnter={() => setIsPaused(true)}
                  onMouseLeave={() => setIsPaused(false)}
                >
                  〉
                </button>
              </div>

              <div className="indicator">
                {ThreeDModels.map((_, idx) => (
                  <span key={idx} className={`dot ${idx === currentIndex ? 'active' : ''}`}></span>
                ))}
              </div>
            </div>
          </div>
        </div>

        <div
          data-aos="fade-up"
          data-aos-easing="ease-out"
          data-aos-duration="1300"
          className="solution_section4"
        >
          <div>
            <img src={hdSafetyMapImg} alt="hd_safety_map 이미지" />
          </div>
          <div id="hd" className="solution_section4_title">
            <div>HD SAFETY MAP</div>
            <div className="solution_section4_description">{t('section4.des')}</div>
          </div>
        </div>

        <div
          data-aos="fade-up"
          data-aos-easing="ease-out"
          data-aos-duration="1300"
          className="solution_section5"
        >
          <div className="solution_section5_title">
            <div id="auto">AUTOMATIC DATA PROCESSING</div>
          </div>
          <div>
            <div>
              <div className="solution_section5_description">{t('section5.des')}</div>
            </div>
            <div className="solution_section5_img_contents">
              {/* <div>
                <img src={automaticDataProcessingGif} alt="automatic_data_processing 이미지" />
              </div> */}
              <div>
                <img src={automaticPlatformImg} alt="automatic_platform 이미지" />
              </div>
            </div>
          </div>
        </div>
      </div>
      <Footer />
    </>
  );
};

export default Solution;
